<template>
    <div class="loginPage" :style="{height:mainHeights+'px'}">
        <div class="bg animated fadeInLeft">
            <a href="https://www.medinbd.com/" target="_blank"><img class="logo n-expand" src="../assets/systemImg/logo-blue.png" alt=""></a>
            <div class="bgImg"></div>
        </div>
        <div class="login-box-fr animated fadeInRight">
            <div class="loginBox">
            <h2>米因AI服務平台企業後台</h2>
            <div class="account framData">
                <input @focus="clearFormErr" :style="{borderColor: errorTip ? '#FF4C52':''}" v-model.trim="phone" type="text" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" placeholder="輸入賬號名" />
            </div>
            <div class="pwd framData">
                <input @focus="clearFormErr" :style="{borderColor: errorTip ? '#FF4C52':''}" v-model="password" maxlength="40" type="password" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" placeholder="請輸入登錄密碼" />
            </div>
			<template v-if="0">
				<h4 class="qjc-c-dark qjc-fts-18 form-subtitle" >人员信息验证</h4>
				<div class="pwd framData form-account" >
					<el-select id="phone-area-select" v-model="loa" @change="clearFormErr" class="form-el-select">
						<el-option label="+852" :value="852" data-sup="中国香港" class="phone-el-select"></el-option>
					  <el-option label="+86" :value="86" data-sup="中国大陆" class="phone-el-select"></el-option>
					</el-select>
				    <input @focus="clearFormErr" class="account-input" :style="{borderColor: errorTip ? '#FF4C52':''}" v-model="mobile" maxlength="20" type="text" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" placeholder="請輸入手机号" />
				</div>
				<div class="pwd framData form-code" >
				    <input @focus="clearFormErr" :style="{borderColor: errorTip ? '#FF4C52':''}" v-model="code" maxlength="6" type="text" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" placeholder="請輸入验证码" />
					<div class="send-code">
						<div v-if="sending" class="sending-text">
							{{ countDown }}
							秒后重发
						</div>
						<div v-else @click="sendCode" :class="isPhone(mobile) ? 'send-code-text isPhone':''" >{{ loginhqyzm }}</div>
					</div>
				</div>
			</template>
			
            <div class="error-message">
                <p>{{ errorMessage }}</p>
            </div>
            <div class="agreement">
                <el-checkbox @change="clearFormErr" size="12" v-model="checked" fill="#40444D">我已閲讀並同意 <span @click="terms = true" style="color: #6681FA;">《米因AI服務平台企業後台服務協議》</span></el-checkbox>
            </div>
            <button class="loginBtn" @click="loginBtn">登錄</button>
        </div>
        </div>
        <div class="termsPopu" v-show="terms">
            <div class="terms">`
			
                <div class="termsTit">
                    米因AI服務平台企業後台服務協議
                    <span @click="terms = false">&#10005;</span>
                </div>
                <ul>
                    <li>
<!--                        <h6>一、特別提示</h6>-->
                        <p class="agreement-special">本協議約定米因智慧醫療（MEDINAI&WISEMEDICALLIMITED，以下簡稱米因）與用戶之間關於“米因健康AI服務平台企業後台”（以下簡稱“後台”）的權利義務。</p>
                        <p>“用戶”是指登錄、使用本後台的機構，“操作員”是指機構用戶指定的、負相關崗位責任的該機構僱員。</p>
                        <p>本協議可由米因隨時更新，更新後的協議條款一旦公布即代替原來的協議條款，恕不再另行通知，用戶可隨時查閱最新版協議條款。在修改協議條款後，如果用戶不接受修改後的條款，請立即停止使用後台，用戶繼續使用後台將被視為接受修改後的協議。</p>
                    </li>
                    <li>
<!--                        <h6>二、賬號註冊</h6>-->
                        <p>1.在米因的認可和允許下，用戶有權在本後台進行以下的操作：
                            <br/><span style="margin-left: 0;color: #777F8F;">（1）個人客戶的會員註冊、套餐開通；</span>
                            <br/><span style="margin-left: 0;color: #777F8F;">（2）查詢套餐開通記錄；</span>
                            <br/><span style="margin-left: 0;color: #777F8F;">（3）查詢、調取個人客戶的健康AI服務體檢報告；</span>
                            <br/><span style="margin-left: 0;color: #777F8F;">（4）調取個人客戶的預約信息；</span>
                        </p>
                        <p>2.用戶在為個人客戶進行會員註冊和套餐開通操作時，需要得到個人客戶的許可，個人客戶應當在自主、自願的前提下將手機接收到的驗證碼以及個人信息告知用戶，並由操作員負責錄入並完成相關操作；</p>
                        <p>3.操作員有義務準確填寫個人客戶的姓名、年齡、性別、出生日期等個人信息，並遵照個人客戶的意願選擇開通相應的套餐；</p>
                        <p>4.用戶清楚了解套餐的開通記錄將作為米因與用戶之間財務結算的主要憑證；</p>
                        <p>5.用戶有義務保護個人客戶的數據隱私，禁止濫用、洩露個人客戶的數據，包括但不限於：
                            <br/><span style="margin-left: 0;color: #777F8F;">（1）在非客戶要求、非必要的情況下隨意查閱、打印、分享個人客戶的健康AI服務體檢報告；</span>
                            <br/><span style="margin-left: 0;color: #777F8F;">（2）將個人客戶的個人信息、健康AI服務體檢報告內容等洩露給無關人員和機構；</span>
                        </p>
                        <p>6.因用戶及其操作員的不正當使用而導致用戶自身的一切損失，米因概不負責；因用戶及其操作員的不正當使用而導致米因遭受損失的，米因有權依法進行追究；因用戶及其操作員的不正當使用而導致任何違法、違紀、隱私洩露、公共危害等問題發生的，米因有權立刻中止與用戶的合作，並在必要時配合有關部門、機構的調查與處理，一切後果由用戶承擔。
                        </p>
                        <p></p>
                    </li>
                </ul>
            </div>
        </div>
        <Alert :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog" @on-confirm="confirmDialog"/>
    </div>
</template>

<script>
    import login from '../assets/js/login'
    import Alert from '../components/alert'
    export default {
        mounted(){
            this.mainHeights = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)
            window.onresize = () => {
				return (() => {
					this.mainHeights = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)
				})();
			};
        },
        components:{
            Alert
        },
        ...login
    }
</script>
<style scoped>
    .loginPage >>> .el-button--primary{
        background-color: #6681FA!important;
    }

	
	.loginPage >>> .el-input__inner{
				border: none;
				line-height: 33px;
			}
	
	
	.loginPage >>> .el-checkbox   .el-checkbox__label{
		color: #606266 ;
	}
	
</style>

<style lang="scss" scoped>
	.form-code{
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		border-bottom:1px solid #dcdfe6;
		
		input{
			flex: 1;
			border: none !important;
			margin-bottom: 0 !important;
		}
		
		.send-code{
			flex:  0 0 auto;
			height: 33px;
			white-space: nowrap;
			display: flex;
			align-items: center;
			>div{
				border-left:1px solid #dcdfe6 ;
				padding: 0 9px;
			}
		}
	}
	
	.form-subtitle{
		margin-bottom: 8px ;
	}
	
	.form-account{
		display:flex;
		align-items: center;
		justify-content: flex-start;
		
		.form-el-select{
			flex: 0 0 auto;
			width: 80px;
			
			
		}
		
		.account-input{
			flex: 1;
		}
	}
	
	.isPhone{
		cursor: pointer;
		color: rgba(102,129,250,1);
	}
	
	.phone-el-select::after{
	  content: attr(data-sup);
	  margin-left: 7px;
	}
	
	.framData{
		&:hover{
			border-color: rgba(102,129,250,1);
		}
	}
</style>

<style src="../assets/css/login.css" scoped>

    
</style>